<div class="row ">

  <div class="col-12">
    <div class="card">
      <div class="card-body animated fadeIn fast">


        <!-- cabecera -->
        <div class="row mb-2">

          <!-- <div class="col-6">
            <div class="form-group border border-dark rounded">
              <input class="form-control"
                     type="text"
                     autofocus
                     placeholder="Buscar cualquier dato..."
                     (keyup)="buscarTodo($event)" />
            </div>
          </div> -->

          <div class="col-6">
            <div class="input-group border border-dark rounded">
              <input class="form-control"
                     type="text"
                     id="buscaTodo"
                     autofocus
                     placeholder="Buscar cualquier dato..."
                     [(ngModel)]="strBuscarTodo"
                     (keyup)="buscarTodo($event)" />
              <div class="input-group-append">
                <button class="btn btn-outline-secondary"
                        type="button"
                        title="Limpiar búsqueda"
                        (click)="limpiaBusca()">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
          </div>



          <div class="col-6">
            <form>

              <div class="row float-right">

                <div class="col-sm-6">
                  <div class="form-group rounded">
                    <select class="form-control"
                            name="rowsLimitStr"
                            [(ngModel)]="rowsLimitStr"
                            (change)="rowsLimitChange()">
                      <option [value]="10">10</option>
                      <option [value]="50">50</option>
                      <option [value]="100">100</option>
                      <option [value]="999999">Todo</option>
                    </select>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="form-group float-right">
                    <div class="btn-group">
                      <button type="button"
                              [routerLink]="'/panel/usuario/new'"
                              class="btn btn-outline-info btn-circle"
                              title="Nuevo">
                        <i class="fa-solid fa-plus"></i>
                      </button>
                      <button type="button"
                              (click)="getLista()"
                              class="btn btn-outline-info btn-circle"
                              title="Recargar datos">
                        <i class="fa-solid fa-sync"></i>
                      </button>
                      <button type="button"
                              (click)="exportToExcel()"
                              class="btn btn-outline-info btn-circle"
                              title="Descargar Excel">
                        <i class="fa-solid fa-download"></i>
                      </button>
                    </div>
                  </div>
                </div>

              </div>

            </form>
          </div>

        </div>



        <div class="rounded border">
          <ngx-datatable class="bootstrap"
                         [rows]="rows"
                         [limit]="rowsLimit"
                         [loadingIndicator]="loading"
                         [columnMode]="'flex'"
                         [headerHeight]="50"
                         [footerHeight]="50"
                         [summaryRow]="false"
                         [summaryHeight]="55"
                         [summaryPosition]="'bottom'"
                         [rowHeight]="'auto'"
                         [reorderable]="true">

            <!-- FOTO -->
            <ngx-datatable-column name=""
                                  prop="foto"
                                  [width]="50"
                                  [maxWidth]="70"
                                  [sortable]="false">
              <ng-template ngx-datatable-cell-template
                           let-row="row"
                           let-value="value">
                <div *ngIf="value">
                  <img [src]="fotoDir +'/users' + imgResized + value"
                       loading="lazy"
                       (click)="abrirModal(row)"
                       alt="Foto"
                       class="rounded pointer"
                       height="30px"
                       width="30px"
                       title="Cambiar/borrar foto">
                </div>
              </ng-template>
            </ngx-datatable-column>

            <!-- USERNAME -->
            <ngx-datatable-column name="username"
                                  [flexGrow]="1">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <div class="header"
                     (click)="sort()">
                  <h6 class="title link">Usuario</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           let-row="row"
                           ngx-datatable-cell-template>
                <span [ngClass]="{'text-danger': row.activo != '1'}"
                      [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></span>
                <span *ngIf="row.activo != '1'"
                      class="ml-1"
                      title="Usuario bloqueado">
                  <i class="text-danger fa-solid fa-ban"></i>
                </span>
              </ng-template>
            </ngx-datatable-column>

            <!-- NOMBRE -->
            <ngx-datatable-column name="nombre"
                                  [flexGrow]="1">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <div class="header"
                     (click)="sort()">
                  <h6 class="title link">Nombre</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           let-row="row"
                           ngx-datatable-cell-template>
                <div [ngClass]="{'text-danger': row.activo != '1'}"
                     [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>

            <!-- APELLIDOS -->
            <ngx-datatable-column name="apellidos"
                                  [flexGrow]="1">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <div class="header"
                     (click)="sort()">
                  <h6 class="title link">Apellidos</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           let-row="row"
                           ngx-datatable-cell-template>
                <div [ngClass]="{'text-danger': row.activo != '1'}"
                     [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>

            <!-- EMAIL -->
            <ngx-datatable-column name="email"
                                  [flexGrow]="2">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <div class="header"
                     (click)="sort()">
                  <h6 class="title link">e-Mail</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           let-row="row"
                           ngx-datatable-cell-template>
                <div [ngClass]="{'text-danger': row.activo != '1'}"
                     [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>

            <!-- TELEFONO -->
            <ngx-datatable-column name="telefono"
                                  [flexGrow]="1">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <div class="header"
                     (click)="sort()">
                  <h6 class="title link">Teléfono</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           let-row="row"
                           ngx-datatable-cell-template>
                <div [ngClass]="{'text-danger': row.activo != '1'}"
                     [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>

            <!-- ROL -->
            <ngx-datatable-column name="rol"
                                  [flexGrow]="1"
                                  [sortable]="false">
              <ng-template ngx-datatable-header-template
                           let-column="column">
                <select class="form-control form-control-sm"
                        (change)="buscaRol($event.target)">
                  <option value="">Todos</option>
                  <option *ngFor="let rol of roles"
                          [value]="rol.valor">{{ rol.texto }}</option>
                </select>
              </ng-template>
              <ng-template let-value="value"
                           let-row="row"
                           ngx-datatable-cell-template>
                <span class="rolUsr"
                      [ngClass]="getRolClass(value)">
                  {{ getRolText(value) }}
                </span>
              </ng-template>
            </ngx-datatable-column>



            <!-- clientesGestionados -->
            <ngx-datatable-column name="clientesGestionados"
                                  [flexGrow]="1">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <div class="header"
                     (click)="sort()">
                  <h6 class="title link">Clientes gestion</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           let-row="row"
                           ngx-datatable-cell-template>
                <div [ngClass]="{'text-danger': row.activo != '1'}"
                     [innerHTML]="funcLib.resaltarTexto(value?.length || '', textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>



            <!-- ROL INTRANET -->
            <ngx-datatable-column name="rolIntranet"
                                  [flexGrow]="1">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <div class="header"
                     (click)="sort()">
                  <h6 class="title link">Rol Intranet</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           let-row="row"
                           ngx-datatable-cell-template>
                {{value | uppercase}}
                <span *ngIf="value"> de </span>
                <span class="font-italic"
                      *ngIf="row.cliente?.nombre">
                  {{row.cliente.nombre}}
                </span>
              </ng-template>
            </ngx-datatable-column>

            <!-- TIMESTAMP -->
            <ngx-datatable-column name="timestamp"
                                  [flexGrow]="1">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <div class="header"
                     (click)="sort()">
                  <h6 class="title link">Último LogIn</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <span *ngIf="value">{{ value | friendlyTimestamp }}</span>
              </ng-template>
            </ngx-datatable-column>

            <!-- ACCIONES -->
            <ngx-datatable-column [flexGrow]="0.5"
                                  [sortable]="false"
                                  [draggable]="false"
                                  [resizeable]="false">
              <ng-template let-row="row"
                           let-value="value"
                           ngx-datatable-cell-template>
                <div ngbDropdown
                     class="d-inline-block"
                     container="body">
                  <button class="btn btn-sm btn-outline-secondary dropdown-toggle"
                          data-toggle="dropdown"
                          type="button"
                          style="border-width: 1px;">
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                  </button>
                  <div class="dropdown-menu dropdown-menu-left">

                    <a (click)="canDeleteRow(row) ? openChangePasswordModal(row) : null"
                       class="link mr-2 pointer dropdown-item"
                       placement="top"
                       title="Cambiar CONTRASEÑA usuario"
                       [ngClass]="{'disabled': !canDeleteRow(row)}">
                      <i class="fa-solid fa-key"></i> Cambiar contraseña
                    </a>

                    <a (click)="irAEditarUsuario(row)"
                       class="link mr-2 pointer dropdown-item"
                       data-toggle="tooltip"
                       title="Editar usuario">
                      <i class="fa-solid fa-edit"></i> Editar
                    </a>

                    <hr style="margin: 0px;">

                    <a (click)="canDeleteRow(row) ? deleteRow(row) : null"
                       class="link mr-2 pointer dropdown-item text-danger"
                       [ngClass]="{'disabled': !canDeleteRow(row)}"
                       placement="top"
                       title="Borrar">
                      <i class="fa-regular fa-trash-can fa"></i> Borrar
                    </a>

                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>

          </ngx-datatable>
        </div>


      </div>
    </div>
  </div>

</div>